<template>
  <div class="home_wrap">
    <van-nav-bar title="Registros de plataforma" left-text="" left-arrow :fixed="true" @click-left="onClickLeft" />
    <van-tabs v-model="nav_active" :background="'transparent'" :color="'#fff'" @change="tabChange" shrink>
      <van-tab title="">
        <template #title>
          <div class="nav_title">
            <span class="ppl">{{ $t("存款清单") }}</span>
          </div>
        </template>
        <div class="select_items">
          <div class="select_item">
            <select id="withdraw" name="withdraw" class="amount-input selectpix" v-model="select_deposit_time"
              @change="selectDepositTimeChange">
              <option value="0" :selected="select_deposit_time == '0'">
                {{ $t("今天") }}
              </option>
              <option value="1" :selected="select_deposit_time == '1'">
                {{ $t("昨天") }}
              </option>
              <option value="7" :selected="select_deposit_time == '7'">
                {{ $t("最近7天") }}
              </option>
              <option value="15" :selected="select_deposit_time == '15'">
                {{ $t("最近15天") }}
              </option>
              <option value="30" :selected="select_deposit_time == '30'">
                {{ $t("最近30天") }}
              </option>
            </select>
          </div>
          <div class="select_item">
            <select id="type" name="type" class="amount-input selectpix" v-model="select_deposit_type"
              @change="selectDepositTypeChange">
              <option value="all" :selected="select_deposit_type == 'all'">
                {{ $t("全部") }}
              </option>
              <option value="1" :selected="select_deposit_type == '1'">
                {{ $t("已付款") }}
              </option>
              <option value="0" :selected="select_deposit_type == '0'">
                {{ $t("未付款") }}
              </option>
            </select>
          </div>
        </div>
        <div v-for="(item, k) in re_list" :key="k" class="recharge-one">
          <div class="order-status">
            <div>{{ $t("网上支付") }}</div>
            <div class="mmm">{{ item.money }}</div>
          </div>
          <div class="money3">
            <div class="order">
              {{ item.createtime }}
            </div>
            <div :class="item.status == 1 ? 'status' : 'unpay'">
              <b v-if="item.status == 1">{{ $t("已付款") }}</b>
              <b v-else>{{ $t("未付款") }}</b>
            </div>
          </div>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>
<script>
import Vue from "vue";
import { Tabs, Tab, NavBar } from "vant";
import Fetch from "../../utils/fetch";
import gameRecord from "../game/gameRecord.vue";
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(NavBar);
export default {
  name: "record",
  components: {
    gameRecord,
  },
  data() {
    return {
      nav_active: 0,
      select_withdraw_time: "today",
      select_withdraw_type: "all",
      select_deposit_time: "0",
      select_deposit_type: "all",
      select_gameRecord_time: "today",
      select_gameRecord_type: "pg",
      re_list: [],
      game_record: [],
      withDrawList: [],
      max_show: 10,
    };
  },
  created() {
    if (this.$route.query.tab) {
      this.nav_active = this.$route.query.tab;
      this.tabChange(this.nav_active);
    } else {
      this.tabChange(this.nav_active);
    }
  },
  mounted() { },
  methods: {
    tabChange(v) {
      this.nav_active = v;
      if (this.nav_active == 1) {
        Fetch("/recharge/record", {
          status: this.select_deposit_type,
          type: this.select_deposit_time,
        }).then((r) => {
          //console.log(r);
          if (r.data) {
            this.re_list = r.data.list;
          }
        });
      }
    },
    selectWithdrawTimeChange() {
      this.withDrawList = [];
      Fetch("/withdrow/getwithdrawbydate", {
        type: this.select_withdraw_time,
        status: this.select_withdraw_type,
      }).then((r) => {
        //console.log(r);
        if (r.data) {
          this.withDrawList = r.data;
        }
      });
    },
    selectWithdrawTypeChange() {
      this.withDrawList = [];
      Fetch("/withdrow/getwithdrawbydate", {
        type: this.select_withdraw_time,
        status: this.select_withdraw_type,
      }).then((r) => {
        //console.log(r);
        if (r.data) {
          this.withDrawList = r.data;
        }
      });
    },
    selectDepositTimeChange() {
      this.re_list = [];
      Fetch("/recharge/record", {
        status: this.select_deposit_type,
        type: this.select_deposit_time,
      }).then((r) => {
        //console.log(r);
        if (r.data) {
          this.re_list = r.data.list;
        }
      });
    },
    selectDepositTypeChange() {
      this.re_list = [];
      Fetch("/recharge/record", {
        status: this.select_deposit_type,
        type: this.select_deposit_time,
      }).then((r) => {
        //console.log(r);
        if (r.data) {
          this.re_list = r.data.list;
        }
      });
    },
    onClickLeft() {
      this.$router.push("/person");
    },
    getRecord(game_type) {
      Fetch("/record/getRecord", {
        type: this.select_gameRecord_time,
        game: this.select_gameRecord_type,
      }).then((r) => {
        if (r.data) {
          this.game_record = r.data;
        }
      });
    },
    doCopy(val) {
      let _this = this;
      let value = val.split()[0];
      this.$copyText(String(value)).then(function (e) {
        _this.$toast({
          background: "#07c160",
          message: _this.$t("复制成功"),
        });
      });
    },
    selectGameRecordType() {
      this.game_record = [];
      this.max_show = 10;
      this.getRecord();
    },
    selectGameRecordChange() {
      this.game_record = [];
      this.max_show = 10;
      this.getRecord();
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../assets/css/variables.less";

/deep/ .van-nav-bar {
  background: @secondary-color;
}

/deep/ .van-nav-bar .van-icon {
  color: #fff;
}

/deep/ .van-nav-bar__title {
  color: #fff;
}

.home_wrap {
  width: 100%;
  min-height: 100vh;
  //background-color: rgb(48, 48, 48);
  padding-bottom: 1.8rem;
  // padding-top: 1.5rem;
}

/deep/ .van-tabs__wrap {
  border-bottom: 0.01rem solid @bodercolor;
  background-color: @secondary-color;
}

/deep/ .nav_title span {
  color: #fff;
  font-size: 0.3rem;
}

select {
  border-radius: 0.5rem;
  color: #fff;
  background-color: @secondary-color;
  padding: 0.1rem 0.2rem;
  border: 0.01rem solid @bodercolor;
  color: #ccc;
  font-size: 0.3rem;
  // padding-right: .4rem;
  // appearance: none;
  // -moz-appearance: none;
  // -webkit-appearance: none;
}

.select_items {
  display: flex;
  justify-content: space-around;
  padding-top: 0.2rem;
  padding-bottom: 0.4rem;
}

.home_wrap {
  width: 100%;
  min-height: 100vh;
  //background-color: rgb(48, 48, 48);
  padding-bottom: 1.8rem;
  padding-top: 1.2rem;
}

.order_no {
  img {
    width: 0.3rem;
  }
}

.game_items {
  width: 100%;

  .game_item {
    width: 90%;
    margin: 0 auto 0.3rem auto;
    border-radius: 0.21053rem;
    color: #fff;
    overflow: hidden;
    position: relative;
    background: @activityColor;
    padding: 0 0;
    font-size: 0.25rem;

    .game_one {
      display: flex;
      justify-content: space-between;
      padding: 0.3rem;

      .game_name {
        color: #fff;
      }
    }

    .game_two {
      display: flex;
      justify-content: space-between;
      padding: 0.3rem;
    }
  }
}

.game_amount>span:first-child {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #fff;
}

.lose {
  color: #ad0000;
  margin-left: 0.2rem;
}

.win {
  color: #04f702;
  margin-left: 0.2rem;
}

.game_amount {
  color: #fff;
}

.game_time {
  color: #fff;
}

.game_id {
  color: #fff;
}

.tpng {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}

.bpng {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}

.myteam-bg {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
}

.showmore {
  height: 30px;
  line-height: 30px;
  cursor: pointer;
}

.ct-time2 {
  padding: 0.2rem 15px;
  font-size: 0.34rem;
  display: flex;
  justify-content: space-between;
}

.ct-time {
  padding: 3px 15px;
  font-size: 0.34rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.is_active {
  padding: 15px 15px;
  font-size: 0.34rem;
  line-height: 16px;
  // display: flex;
  justify-content: space-between;
}

.mdec {
  margin-top: 10px;
  width: 100%;
  color: #fff;
}

.mmm {
  //   width: 100%;
  font-weight: 700;
  color: gold;
}

.show_more {
  color: #fff;
  width: 95%;
  margin: 0.3rem auto;
  border-radius: 0.2rem;
  text-align: center;
  font-size: 0.35rem;
}

.m-1 {
  width: 33.33%;
  padding: 0;
  text-align: center;
}

.m-1:nth-child(1) {
  border-right: 1px solid #e5e5e5;
}

.m-1:nth-child(2) {
  border-right: 1px solid #e5e5e5;
}

.money3 {
  //   width: 95%;
  margin: 0 auto;
  padding: 10px 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fff;
  //border-bottom: thin solid rgba(126, 126, 126, 0.1);
}

.order {
  font-size: 0.3rem;
}

select#gameType {
  width: 3rem;
}

.status {
  // width: 60px;
  //   padding: 0 15px;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  //background: linear-gradient(to right, rgb(166, 0, 146), rgb(97, 17, 207));
}

.unpay,
.unpay1,
.unpay2,
.unpay3,
.unpay4 {
  // width: 60px;
  //   padding: 0 15px;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  color: #fff;
  color: #fc661e;
  //background:  linear-gradient(90deg, #3FBBFE 0%, #A541FF 100%);
}

.order-status {
  width: 100%;
  box-sizing: border-box;
  //   padding: 0.1rem 0 0.1rem 15px;
  padding: 0.26316rem 0.26316rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  //   border-bottom: thin solid #e5e5e5;
}

.recharge-one {
  width: 90%;
  margin: 0 auto 0.3rem auto;
  border-radius: 8px;
  color: #fff;
  overflow: hidden;
  position: relative;
  //border: 1px solid #895DB3;
  background: @activityColor;
  padding: 0 0;
  font-size: 0.3rem;
}

.basic_wrap {
  margin-top: 0;
  padding-top: 1.8rem;
  position: relative;
}
</style>